import { env } from "~/env";
import { VISIT_TYPES, VisitType } from "~/services/scheduling";
import { INTERSTITIAL_VARIANTS } from "./constants";
import type { InterstitialVariant } from "./types";

export const isInterstitialVariant = (
  variant: InterstitialVariant | null,
): boolean =>
  variant === INTERSTITIAL_VARIANTS.QUESTION_AND_CONTEXT ||
  variant === INTERSTITIAL_VARIANTS.ONLY_CONTEXT;

export const resolveNirvanaEnabled = ({
  visitType,
  isLoggedIn,
}: {
  visitType: VisitType;
  isLoggedIn: boolean;
}): boolean => {
  if (visitType !== VISIT_TYPES.INITIAL || isLoggedIn) {
    return false;
  }

  return Math.random() < Number(env.VITE_AB_TEST_NIRVANA_PERCENTAGE);
};

export const resolveInterstitialVariant = ({
  visitType,
  isLoggedIn,
}: {
  visitType: VisitType;
  isLoggedIn: boolean;
}): InterstitialVariant => {
  if (visitType !== VISIT_TYPES.INITIAL || isLoggedIn) {
    return INTERSTITIAL_VARIANTS.CONTROL;
  }

  const questionAndContext = Number(
    env.VITE_AB_TEST_QUESTION_AND_CONTEXT_PERCENTAGE,
  );
  const onlyContext = Number(env.VITE_AB_TEST_ONLY_CONTEXT_PERCENTAGE);
  const random = Math.random();

  if (random < questionAndContext) {
    return INTERSTITIAL_VARIANTS.QUESTION_AND_CONTEXT;
  }
  if (random < questionAndContext + onlyContext) {
    return INTERSTITIAL_VARIANTS.ONLY_CONTEXT;
  }
  return INTERSTITIAL_VARIANTS.CONTROL;
};
